module.exports = new __parcel__URL__("r1_poster.07f3bdb3.jpg").toString();